import { EditableGridPage } from "@repo/ui";
import { useCallback } from "react";

import { useTrainingQueries } from "../../../api/trainingApi";
import {
	StateSpecificTrainingProvider,
	useRepContext,
	useStateSpecificTrainingContext,
} from "../../../contexts/editableItemContext";
import { usePermissionsCheck } from "../../../helpers/permissions";
import { useEntityId, useUpdateRoute } from "../../../helpers/urlHooks";
import { MVCStateSpecificTraining } from "../../../models/MVCStateSpecificTraining";
import { Props } from "../types";
import StateSpecificTrainingEditorDynamic from "./editor";
import StateSpecificTrainingGridBasic from "./grid";

function StateSpecificTraining(props: Props) {
	return (
		<StateSpecificTrainingProvider>
			<StateSpecificTrainingInternal {...props} />
		</StateSpecificTrainingProvider>
	);
}

const StateSpecificTrainingInternal = (props: Props) => {
	const { repId } = useRepContext();
	const { overwriteItem, pendingChanges } = useStateSpecificTrainingContext();

	const { useStateSpecificTrainingsQuery } = useTrainingQueries();
	const { data, loaded } = useStateSpecificTrainingsQuery();
	const entityId = useEntityId();
	const updateRoute = useUpdateRoute();

	const { fullAPReadOnly } = usePermissionsCheck();

	const handleOpen = (item: MVCStateSpecificTraining) => {
		overwriteItem(item);
	};

	const newItem = useCallback(() => {
		overwriteItem({
			trainingDate: new Date(),
		} as MVCStateSpecificTraining);
	}, [overwriteItem, repId]);

	return (
		<EditableGridPage<MVCStateSpecificTraining>
			id="StateSpecificTrainingsContainer"
			items={data}
			keyProperty="id"
			Editor={StateSpecificTrainingEditorDynamic}
			Grid={StateSpecificTrainingGridBasic}
			openItem={handleOpen}
			pendingChanges={pendingChanges}
			newItem={newItem}
			itemsLoaded={loaded}
			readOnly={props.readOnly}
			entityId={entityId}
			updateRoute={updateRoute}
			fullReadOnly={fullAPReadOnly}
		/>
	);
};

export default StateSpecificTraining;
